/**
 * AI Documents Feature Routes
 * RAG 기반 AGM 문서 자동 생성
 */

import type { RouteRecordRaw } from 'vue-router';

export const aiDocumentsMvpRoutes: RouteRecordRaw[] = [
  {
    path: '/ai-documents-mvp',
    name: 'AIDocumentsMvp',
    component: () => import('./views/AIDocumentsView.vue'),
    meta: {
      title: 'AI Documents MVP',
      requiresAuth: true,
      layout: 'full',
      devOnly: true,
    },
  },
  {
    path: '/doc-gen-mvp',
    name: 'DocGenMvp',
    component: () => import('./views/DocGenView.vue'),
    meta: {
      title: 'Document Generation MVP',
      requiresAuth: true,
      layout: 'full',
      devOnly: true,
    },
  },
];

export default aiDocumentsMvpRoutes;
